import { useDispatch } from 'react-redux';
import Swal from 'sweetalert2';
import { Modal } from 'react-bootstrap';
import { Form } from 'react-bootstrap';
import { UIActions } from '../../presentation/redux/actions/UIActions';
import { useForm } from '../../presentation/hooks/useForm';
import { newPinUsuario } from '../action/pinUsuario';
import PasswordStrengthBar from 'react-password-strength-bar';

interface ModalProps {
  isOpen: boolean;
  toggle: Function;
  token: string;
}

export const ModalNuevoPin: React.FC<ModalProps> = (props: ModalProps) => {
  const dispatch = useDispatch();
  const { isOpen, toggle, token } = props;
  const [formValues, handleInputChange, reset]: any = useForm();

  const onSubmit = (e: any) => {
    e.preventDefault();
    if (isValid()) {
      dispatch(UIActions.uiLoadActive());
      newPinUsuario(token, formValues, dispatch);
      closeModal();
    }
  }

  const isValid = () => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!formValues.nombre || formValues.nombre.trim().length === 0) {
      Swal.fire('Advertencia', 'Nombre es requerido', 'warning');
      return false;
    } else if (!formValues.telefono || formValues.telefono.trim().length === 0) {
      Swal.fire('Advertencia', 'Teléfono es requerido', 'warning');
      return false;
    } else if (!formValues.email || formValues.email.trim().length === 0) {
      Swal.fire('Correo no valido', 'Ingresa un correo', 'warning');
      return false;
    } else if (!emailRegex.test(formValues.email)) {
      Swal.fire('Correo no valido', 'Ingresa un correo valido. Asegúrate de que el formato del correo electrónico sea correcto', 'warning');
      return false;
    } else if (!formValues.password || formValues.password.trim().length === 0) {
      Swal.fire('Advertencia', 'Contraseña es requerida', 'warning');
      return false;
    } else if (formValues.password && formValues.password.trim().length < 8) {
      Swal.fire('Advertencia', 'La contraseña debe tener mínimo 8 caracteres', 'warning');
      return false;
    } else if ((formValues.password) && formValues.password !== formValues.confirmpassword) {
      Swal.fire('Advertencia', 'Las contraseña no coinciden', 'warning');
      return false;
    } else if ((formValues.password) && (!(/[a-z]/.test(formValues.password)) || !(/[A-Z]/.test(formValues.password)) || !(/[0-9]/.test(formValues.password)))) {
      Swal.fire({
        icon: 'warning',
        title: 'Advertencia',
        html:
          'La contraseña debe tener al menos: ' +
          (!(/[a-z]/.test(formValues.password)) ? '<li><b>Una minúscula</b></li> ' : '') +
          (!(/[A-Z]/.test(formValues.password)) ? '<li><b>Una mayúscula</b></li> ' : '') +
          (!(/[0-9]/.test(formValues.password)) ? '<li><b>Un número</b></li> ' : '')
      });
      return false;
    }
    return true;
  }

  const closeModal = () => {
    toggle();
    reset({});
  }

  return (
    <Modal
      onHide={closeModal}
      show={isOpen}
      backdrop="static"
      aria-labelledby="contained-modal-title-vcenter"
      centered>
      <Modal.Header closeButton className='gradientBlue colorWhite'>
        <Modal.Title id="contained-modal-title-vcenter">
          Nuevo Pin Usuario
        </Modal.Title>
      </Modal.Header>
      <Modal.Body
        className='p-2 bg-light'>
        <div className='d-flex flex-column'>
          <Form onSubmit={onSubmit}>
            <div>
              <Form.Label className='col-form-label'>Nombre*</Form.Label>
              <Form.Control
                onChange={handleInputChange}
                id="nombre"
                name="nombre"
                type="text"
                autoComplete='off'
                maxLength={80}
                placeholder="Ingresa nombre">
              </Form.Control>
            </div>
            <div>
              <Form.Label className='col-form-label'>Teléfono*</Form.Label>
              <Form.Control
                onChange={handleInputChange}
                id="telefono"
                name="telefono"
                type="number"
                maxLength={10}
                autoComplete='off'
                placeholder="Ingresa teléfono"
                onInput={(e: any) => {
                  if (e.target.value.length > e.target.maxLength)
                    e.target.value = e.target.value.slice(0, e.target.maxLength);
                }}
              >
              </Form.Control>
            </div>
            <div>
              <Form.Label className='col-form-label'>Email*</Form.Label>
              <Form.Control
                onChange={handleInputChange}
                id="email"
                name="email"
                autoComplete='off'
                type="email"
                maxLength={50}
                placeholder="Ingresar email"
              >
              </Form.Control>
            </div>
            <div>
              <Form.Label className='col-form-label'>Contraseña*</Form.Label>
              <Form.Control
                onChange={handleInputChange}
                id="password"
                name="password"
                type="password"
                autoComplete='off'
                maxLength={80}
                placeholder="Contraseña mínimo 8 caracteres">
              </Form.Control>
              {(formValues.password) &&
                <>
                  <div className='px-3'>
                    <PasswordStrengthBar
                      shortScoreWord='demasiado corta'
                      scoreWords={['débil', 'débil', 'okey', 'buena', 'fuerte']}
                      password={formValues.password} />
                  </div>
                </>
              }
            </div>
            <div>
              <Form.Label className='col-form-label'>Confirmar contraseña*</Form.Label>
              <Form.Control
                onChange={handleInputChange}
                id="confirmpassword"
                name="confirmpassword"
                type="password"
                autoComplete='off'
                maxLength={80}
                placeholder="Confirmar contraseña">
              </Form.Control>
            </div>
          </Form>
        </div>
      </Modal.Body>
      <Modal.Footer className='bg-light'>
        <button onClick={() => closeModal()} className="btn btn-light btn-outline-secondary float-right">Cancelar</button>
        <button onClick={onSubmit} className="btn btn-primary float-right" type="submit">
          Guardar
        </button>
      </Modal.Footer>
    </Modal>
  )
}